import { h } from "preact";
import Button from "../Button";
import classname from "../../foundation/utils/classname";
import ButtonGroupItem from "./ButtonGroupItem";

import "./style.css";

interface Props {
    class?: string;
    buttonClass?: string;
    items: ButtonGroupItem[];
    selected: string | null | undefined;
    alignment?: "horizontal" | "vertical";
    onChange: (value: string) => void;
}

function ButtonGroup({
    class: cssClass,
    buttonClass,
    items,
    selected,
    alignment = "horizontal",
    onChange
}: Props) {
    function createClickHandler(selectedValue: string) {
        return function () {
            onChange(selectedValue);
        };
    }

    return (
        <div class={classname("buttonGroup", cssClass, { [alignment]: true })}>
            {items.map(item => (
                <Button
                    class={classname("buttonGroupItem", buttonClass, { selected: item.value === selected })}
                    key={item.value}
                    secondary
                    onClick={createClickHandler(item.value)}>
                    {item.content}
                </Button>
            ))}
        </div>
    );
}

export default ButtonGroup;
